import { render } from "./CmsProductLinksPopup.vue?vue&type=template&id=634effc4&scoped=true"
import script from "./CmsProductLinksPopup.vue?vue&type=script&lang=js"
export * from "./CmsProductLinksPopup.vue?vue&type=script&lang=js"

import "./CmsProductLinksPopup.vue?vue&type=style&index=0&id=634effc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634effc4"]])

export default __exports__